// Recovered compiled webpack factory 57562. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  (a.r(t), a.d(t, { Reveal: () => o }));
  var r = a(95155),
    n = a(41407),
    i = a(32164);
  let s = [0.16, 1, 0.3, 1];
  function o(e) {
    let { children: t, className: a = "", index: o = 0, columns: l = 3, y: c = 16, delay: d } = e;
    return (0, n.I)()
      ? (0, r.jsx)("div", { className: a, children: t })
      : (0, r.jsx)(i.P.div, {
          className: `um-reveal ${a}`.trim(),
          initial: { opacity: 0, y: c },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: !0, margin: "0px 0px -90px 0px" },
          transition: { duration: 0.5, delay: d ?? (o % l) * 0.06, ease: s },
          children: t,
        });
  }
}
